import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductStockLookupDTO } from "../../../types/inventory/stock/ProductStockLookupTypes";

interface ProductStockLookupState {
  list: ProductStockLookupDTO[];
  paginator: any;
  isLoading: boolean;
  error: string | null;
}

const initialState: ProductStockLookupState = {
  list: [],
  paginator: null,
  isLoading: false,
  error: null,
};

const productStockLookupSlice = createSlice({
  name: "productStockLookup",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    setList(
      state,
      action: PayloadAction<{ content: ProductStockLookupDTO[]; paginator: any }>
    ) {
      state.list = action.payload.content;
      state.paginator = action.payload.paginator;
      state.error = null;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    clearList(state) {
      state.list = [];
      state.paginator = null;
      state.error = null;
    },
  },
});

export const {
  setLoading,
  setList,
  setError,
  clearList,
} = productStockLookupSlice.actions;

export default productStockLookupSlice.reducer;
